import { Observable } from 'rxjs';

import { AuthenticationDevice } from './models/authentication-device';

export abstract class DeviceAuthenticationApiService {
	public abstract getDevices$(deviceIds: string[]): Observable<AuthenticationDevice[]>;
}
